/* eslint-disable @typescript-eslint/naming-convention */

/**
 * External Credentials Types and Interfaces
 * These will be provided by PR 24235 when it merges
 * For now, we define them here to align with PR 24235's schema
 */

export interface ExternalCredentials {
    IntegrationType: ExternalCredentialType;
    ClientId?: string;
    Secret?: string;
    CreatedAt?: Date;
    UpdatedAt?: Date;
}

export enum ExternalCredentialType {
    Hapn = 'hapn',
    MatrixIq = 'MATRIXIQ'
}

/**
 * External Provider OAuth Request (HAPN, etc.)
 */
export interface ExternalProviderRequest {
    grant_type: string;
    client_id: string;
    client_secret: string;
}

/**
 * External Provider OAuth Response (HAPN, etc.)
 */
export interface ExternalProviderResponse {
    access_token?: string;
    token_type?: string;
    expires_in?: string;
    scope?: string;
    error?: string;
    error_message?: string;
}
